import { node, string, bool, object } from 'prop-types'
import React, { Fragment, Children, useState } from 'react'
import Tooltip from '../Tooltip'

const applyFocusHandler = (showOnTabFocus, child, setFocus) => {
  if (showOnTabFocus) {
    const focusHandler = () => setFocus(true)
    const blurHandler = () => setFocus(false)
    return React.cloneElement(child, {
      onFocus: focusHandler,
      onBlur: blurHandler,
    })
  }

  return child
}

const WithTooltip = ({
  children,
  className,
  content,
  disabled,
  inline = false,
  interactive = false,
  showOnTabFocus = true,
  tooltipOptions,
}) => {
  const [tabFocused, setTabFocused] = useState(false)
  return (
    <Fragment>
      {disabled ? (
        Children.only(children)
      ) : (
        <Tooltip
          {...tooltipOptions}
          className={className}
          interactive={interactive}
          inline={inline}
          open={tabFocused}
          content={content}
          trigger={applyFocusHandler(
            showOnTabFocus,
            Children.only(children),
            setTabFocused
          )}
        />
      )}
    </Fragment>
  )
}

WithTooltip.propTypes = {
  children: node.isRequired,
  className: string,
  content: string,
  disabled: bool,
  inline: bool,
  interactive: bool,
  showOnTabFocus: bool,
  tooltipOptions: object,
}

export default WithTooltip
